import { Button, Icon, List, ModalWindow, Text } from "@ucl/react-library";
import { Trans, useTranslation } from "react-i18next";
import { translationMapping } from "src/utils/translation-mappings";
import { InlineAlertMessage } from "../inline-alert-message/inline-alert-message";

interface ConfirmModalProps {
  isOpen: boolean;
  handleSubmit: () => void;
  handleCancel: () => void;
  translationKey: string;
  showError?: boolean;
}

export const ConfirmModal = ({ isOpen, handleSubmit, handleCancel, translationKey, showError = false }: ConfirmModalProps) => {

  const { t } = useTranslation();
  const paragraphs = t(`${translationKey}.paragraphs`, { returnObjects: true });
  const buttonColor = translationKey === "confirmLeaveSchemeModal" ? "danger" : "default";
  return (
    <ModalWindow isOpen={isOpen} className="m-5" data-testid="confirmModal">
      <ModalWindow.Header hasClose={false}>
        <Text renderAs="h1" styleType="h2" fontWeight="semi-bold">
          {t(`${translationKey}.title`)}
        </Text>
      </ModalWindow.Header>

      <ModalWindow.Body>
        <div className="flex flex-col items-start gap-3 p-5 bg-gray-100 rounded-xl">
          {Array.isArray(paragraphs) &&
            paragraphs.map((para, index) => (
              <div key={index}>
                {Array.isArray(para) ? (
                  <List type="bullet">
                    {para.map((item) => (
                      <List.Item key={item}>
                        <Text.P size="large">{item}</Text.P>
                      </List.Item>
                    ))}
                  </List>
                ) : (
                  <Text.P size="large">
                    <Trans
                      i18nKey={`${translationKey}.paragraphs.${index}`}
                      components={translationMapping(t)}
                    />
                  </Text.P>
                )}
              </div>
            ))}
        </div>
      </ModalWindow.Body>

      <ModalWindow.Footer className="flex flex-col gap-5">
        {showError && (
          <InlineAlertMessage
            title={t("errors.updateGeneric.title")}
            body={
              <Trans
                i18nKey="errors.updateGeneric.body"
                components={translationMapping(t)}
              />
            }
          />
        )}

        <div className="flex flex-col gap-4 w-full sm:flex-row-reverse sm:justify-between sm:items-center">
          <Button color={buttonColor} onClick={handleSubmit} className="w-full sm:w-auto">
            {t(`${translationKey}.confirm`)}
          </Button>
          <Button variant="tertiary" onClick={handleCancel} className="w-full sm:w-auto flex justify-center items-center">
            <Icon icon="caretLeft" />
            {t(`${translationKey}.cancel`, t("common.goBack"))}
          </Button>
        </div>
      </ModalWindow.Footer>
    </ModalWindow>
  );
};
